import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import * as felaRules from './Quotation.rules';

export interface QuotationProps {
    author?: string;
    children: React.ReactNode;
}

export const Quotation = ({ children, author }: QuotationProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    return (
        <figure className={styles.container}>
            <blockquote className={styles.quote}>{children}</blockquote>
            {author && <figcaption className={styles.author}>{author}</figcaption>}
        </figure>
    );
};
